export const ListItemTypes = {
  DOCUMENT: 'signer',
};
